import React, { useEffect } from 'react';

import { useFilters } from '@/utils';

import { useFavoriteReportHandler } from '../../hooks';
import { ReportDetailsProps, ReportTab, ReportTypeKeys } from '../../report.types';
import { useGetReportEmployerId } from '../hooks';
import ReportDetailsBase from '../ReportDetailsBase';

import {
  PlanOmnibusBalanceReportTableParams,
  PlanOmnibusBalanceSummaryReportParams,
} from './PlanOmnibusBalanceReport.types';
import PlanOmnibusBalanceReportSummary from './PlanOmnibusBalanceReportSummary';
import PlanOmnibusBalanceReportTable from './PlanOmnibusBalanceReportTable';

type FiltersValues = PlanOmnibusBalanceReportTableParams &
  PlanOmnibusBalanceSummaryReportParams & {
    tab: ReportTab;
  };
interface Props extends ReportDetailsProps<FiltersValues> {}
const PlanOmnibusBalanceReportDetails: React.FC<Props> = ({
  defaultEmployerId,
  defaultTab,
  isPreviewMode,
  onChangeFilters,
  defaultFilterValues,
}) => {
  const employerId = useGetReportEmployerId();
  const { filtersValues, setFilterValue } = useFilters<FiltersValues>(
    {
      tab: defaultTab || ReportTab.Summary,
      employerId: defaultEmployerId || employerId || '',
      searchString: '',
      isSSNShowed: false,
      isContributionMode: true,
      startDate: null,
      endDate: null,
      reportPlanIds: [],
      planYearPeriod: [],
      planIds: [],
      ...defaultFilterValues,
    },
    {
      disabled: isPreviewMode,
      autoClear: true,
    }
  );

  useEffect(() => {
    if (isPreviewMode) {
      return;
    }
    setFilterValue.startDate(null);
    setFilterValue.endDate(null);
    setFilterValue.reportPlanIds([]);
    setFilterValue.planYearPeriod([]);
    setFilterValue.planIds([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtersValues.employerId, filtersValues.employerIds?.join(',')]);
  useEffect(() => {
    if (employerId && !filtersValues.employerId) {
      setFilterValue.employerId(employerId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [employerId]);
  useEffect(() => {
    if (defaultTab) {
      setFilterValue.tab(defaultTab);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultTab]);
  useEffect(() => {
    if (isPreviewMode && onChangeFilters) {
      onChangeFilters(filtersValues);
    }
  }, [filtersValues, isPreviewMode, onChangeFilters]);
  useEffect(() => {
    if (!isPreviewMode) {
      setFilterValue.reportPlanIds([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtersValues.employerId]);
  const { isFavorite, handleToggleReportKey } = useFavoriteReportHandler(ReportTypeKeys.PlanOmnibusBalance);
  return (
    <ReportDetailsBase
      isPreviewMode={isPreviewMode}
      isFavorite={isFavorite}
      onToggleFavorite={handleToggleReportKey}
      tab={filtersValues.tab}
      onSetTab={setFilterValue.tab}
      title="Plan Omnibus Balance"
    >
      {filtersValues.tab === ReportTab.Report ? (
        <PlanOmnibusBalanceReportTable
          defaultEmployerId={defaultEmployerId}
          isPreviewMode={isPreviewMode}
          key={filtersValues.tab}
          filtersValues={filtersValues}
          onSetFilterValue={setFilterValue}
        />
      ) : (
        <PlanOmnibusBalanceReportSummary
          defaultEmployerId={defaultEmployerId}
          isPreviewMode={isPreviewMode}
          filtersValues={filtersValues}
          onSetFilterValue={setFilterValue}
        />
      )}
    </ReportDetailsBase>
  );
};

export default PlanOmnibusBalanceReportDetails;
